import React from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  IconButton,
} from "@material-tailwind/react";
import { navigate } from "astro/virtual-modules/transitions-router.js";
import { CurlyArrowLarge, CurlyArrowSmall } from "../../../common/icons";

export interface AdvanceSearchLoginModalData {
  title: {
    simpleText: string;
    coloredText: string;
  };
  button1: {
    text: string;
    link: string;
  };
  button2: {
    text: string;
    link: string;
  };
  image: string;
}

interface FilterModalProps {
  open: boolean;
  handleOpen: () => void;
  advanceSearchLoginModaldata: AdvanceSearchLoginModalData;
}
export function FilterModal({
  open,
  handleOpen,
  advanceSearchLoginModaldata,
}: FilterModalProps) {
  const { title, button1, button2, image } = advanceSearchLoginModaldata;
  const [buttonSize, setButtonSize] = React.useState<"sm" | "md">("md");
  React.useEffect(() => {
    const handleResize = () => {
      setButtonSize(screen.width < 768 ? "sm" : "md");
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Dialog size={"lg"} open={open} handler={handleOpen} className="h-450px">
        <DialogHeader className="justify-end">
          <IconButton
            color="blue-gray"
            size="sm"
            variant="text"
            onClick={handleOpen}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              className="h-5 w-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </IconButton>
        </DialogHeader>
        <DialogBody className=" bg-[url(/images/modal/lines-pattern.png)] bg-no-repeat bg-center md:bg-right-bottom bg-contain md:pt-6 md:pb-16 px-2 md:!px-12">
          <div className="flex flex-col-reverse md:flex-row md:gap-16 items-center justify-center">
            <div className="flex flex-col items-center md:items-start justify-start gap-2 md:gap-0">
              <div className="flex flex-col-reverse md:flex-col items-center md:items-start">
                <p className=" relative font-bold text-black  whitespace-normal w-[290px] md:w-[340px] leading-[19.36px] md:leading-[30px] md:text-xl text-base text-center md:text-start">
                  {title.simpleText}
                  <br className="hidden md:block" />
                  <span
                    style={{ color: "rgb(85, 81, 255)", fontWeight: "bolder" }}
                  >
                    {title.coloredText}
                  </span>
                  <CurlyArrowLarge className="hidden md:block md:absolute -right-24 top-24" />
                </p>

                <img
                  className="max-w-[44%] md:max-w-[50%] h-auto"
                  src="/images/modal/lock.GIF.gif"
                />
              </div>
              <div className="flex flex-row-reverse w-full justify-center gap-2 md:gap-0 md:flex-row md:justify-center">
                <Button
                  size={buttonSize}
                  variant="filled"
                  className="rounded-full w-[150px]  md:w-[200px] border-primary border text-sm md:text-base  md:px-10 text-primary md:text-white bg-white  md:bg-primary normal-case mr-0 md:mr-2.5 md:hover:bg-primary-hover shadow-none  hover:shadow-none"
                  onClick={() => navigate(button1.link)}
                >
                  {button1.text}
                </Button>

                <Button
                  size="lg"
                  variant="text"
                  className="normal-case w-[150px] md:w-auto rounded-full text-base md:text-primary text-white bg-primary md:bg-transparent  md:hover:bg-gray-100 shadow-none hover:shadow-none"
                  onClick={() => navigate(button2.link)}
                >
                  {button2.text}
                </Button>
              </div>
            </div>
            <div className="relative flex flex-col px-4 md:px-0 items-center justify-center md:w-[230%]">
              <img src={image} className="w-full h-full" />
              <CurlyArrowSmall className="md:hidden absolute -left-2 bottom-0" />
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
}
